import ajax from '../../utils/ajax';
import { SiteSerializer } from '../../models';
import { map } from 'rxjs/operators/map';

function sortName(s1,s2){
  let a = s1.value.toLowerCase();
  let b = s2.value.toLowerCase();
  if(a> b){
    return 1;
  }
  if(a<b){
    return -1;
  }
  if(a===b){
    return 0;
  }
}

class OrganizationService {
  conductorUrl = process.env.REACT_APP_CONDUCTOR_ASSETS_URL || '';
  configurationPathGroup = '/networkAsset/airfinder/organizations';
  configurationPath = '/networkAsset/airfinder/organization';
  configurationPathSites = '/networkAsset/airfinder/sites';

  // get a list of orgs, filtered by account, if allowed by caller
  getOrgs = (store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPathGroup}`,
        body: '',
        headers: { 'Content-Type': 'application/json' },
        method: 'GET',
        responseType: 'json'
      },
      store
    )
  }

  // get sites by org id
  getOrgSites = (store, orgid) => {
    if(orgid){
      return ajax(
        {
          url: `${this.conductorUrl}${this.configurationPath}/${orgid}/sites`,
          body: '',
          headers: { 'Content-Type': 'application/json' },
          method: 'GET',
          responseType: 'json'
        },
        store
      ).pipe(map(data => data.response.sort(sortName).map(SiteSerializer.normalize)));
    } else {
      return ajax(
        {
          url: `${this.conductorUrl}${this.configurationPathSites}`,
          body: '',
          headers: { 'Content-Type': 'application/json' },
          method: 'GET',
          responseType: 'json'
        },
        store
      ).pipe(map(data => data.response.sort(sortName).map(SiteSerializer.normalize)));      
    }
  }

  // get the organization users role string
  getOrgUserRole = (store, orgid) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}/${orgid}/user`,
        body: '',
        headers: { 'Content-Type': 'application/json' },
        method: 'GET',
        responseType: 'json'
      },
      store
    )
  }
}

export default new OrganizationService();



// WEBPACK FOOTER //
// ./src/services/organizations/index.js